// removed by extract-text-webpack-plugin
module.exports = {"bubble-collection":"bubble-collection__bubble-collection___1G6JT","bubble-collection__inner":"bubble-collection__bubble-collection__inner___hGJ4N"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Bubble-collection/bubble-collection.scss
// module id = 113
// module chunks = 0